import React from "react";
import { Box, CircularProgress, Dialog } from "@mui/material";
import { CHRISTMAS, FROST, HALLOWEEN, NIGHT } from "../public/halloween/season";
import { Pumpkin } from "../public/halloween/sprites";
import Sprite from "../public/christmas/Sprite";
import { ICONS } from "../public/christmas/atlas";

const LoadingDialog = () => {
  return (
    <Dialog
      className="loading-dialog"
      open={true}
      PaperProps={{
        style: {
          padding: "10px 10px 10px 10px",
        },
      }}
    >
      {HALLOWEEN ? (
        // Still unmistakably a spinner — just an orange one, round a lantern.
        <Box sx={{ position: "relative", width: 40, height: 40 }}>
          <CircularProgress sx={{ color: NIGHT.pumpkin }} />
          <Pumpkin
            style={{ position: "absolute", top: 11, left: 10, width: 20, height: "auto" }}
          />
        </Box>
      ) : CHRISTMAS ? (
        // A gold spinner round a Christmas ornament.
        <Box sx={{ position: "relative", width: 40, height: 40 }}>
          <CircularProgress sx={{ color: FROST.goldDeep }} />
          <Sprite
            atlas={ICONS}
            name="ornamentRed"
            scale={0.22}
            style={{ position: "absolute", top: 9, left: 11 }}
          />
        </Box>
      ) : (
        <CircularProgress />
      )}
    </Dialog>
  );
};

export default LoadingDialog;
